export function getFeedbackStorageKey(petitionId: string): string {
	return `ai_summary_feedback_${petitionId}`;
}
